<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Select Validation Session'"
        :footerButtons="footerButtons"
        :width="'80%'"
        :height="'90vh'"
        :bodyScrollable="false"
        @cancel="closeModal"
        @footer-click="handleFooterClick"
      >
        <SelectValSession
          ref="selectValSession"
          :profileId="profileId"
          :projectId="projectId"
          :experimentId="experimentId"
          :trainSessionId="trainSessionId"
          @step-change="handleStepChange"
          @create="handleCreate"
        />
      </BaseDialog>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';
import SelectValSession from '@/components/ProfilerComponents/SelectValSession.vue';

const emit = defineEmits(['create']);

const props = defineProps({
  profileId: {
    type: Number,
    default: 0,
  },
  projectId: {
    type: Number,
    default: 0,
  },
  experimentId: {
    type: Number,
    default: 0,
  },
  trainSessionId: {
    type: Number,
    default: 0,
  },
});

const localShow = ref(false);
const selectValSession = ref(null);
const currentStep = ref(0);
const totalSteps = 4;

const footerButtons = computed(() => (
  currentStep.value === totalSteps - 1 ? ['Cancel', 'Create'] : ['Cancel', 'Next']
));

function showModal() {
  localShow.value = true;
  selectValSession.value?.initializeForm?.();
}

function closeModal() {
  localShow.value = false;
}

function handleStepChange(step) {
  currentStep.value = Number(step) || 0;
}

function handleFooterClick(buttonLabel) {
  const label = String(buttonLabel || '').toLowerCase();
  if (label === 'next') {
    selectValSession.value?.nextStep?.();
    return;
  }
  if (label === 'create') {
    selectValSession.value?.createSession?.();
  }
}

function handleCreate(payload) {
  emit('create', payload);
  closeModal();
}

defineExpose({
  showModal,
  closeModal,
});
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.dialog-template__body) {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
</style>

